import React from 'react'

function Error() {
  return (
    <h5>An error seems to have occurred. Please check the url.</h5>
  )
}

export default Error